import React, { Dispatch, SetStateAction, useContext, useState } from 'react';

export interface UsePreviewKeyBoardContextProps {
    currentPreviewIndexFocused: number;
    setCurrentPreviewIndexFocused: Dispatch<SetStateAction<number>>;
    indexFocusedByClick: number;
    setIndexFocusedByClick: Dispatch<SetStateAction<number>>;
}

export const UsePreviewKeyBoardInitialState: UsePreviewKeyBoardContextProps = {
    currentPreviewIndexFocused: 0,
    setCurrentPreviewIndexFocused: () => undefined,
    indexFocusedByClick: 0,
    setIndexFocusedByClick: () => undefined,
};

export const UsePreviewKeyBoardContext =
    React.createContext<UsePreviewKeyBoardContextProps>(
        UsePreviewKeyBoardInitialState,
    );

export const UsePreviewKeyBoardProvider: React.FC = ({ children }) => {
    const [currentPreviewIndexFocused, setCurrentPreviewIndexFocused] =
        useState(0);

    const [indexFocusedByClick, setIndexFocusedByClick] = useState(0);

    return (
        <UsePreviewKeyBoardContext.Provider
            value={{
                currentPreviewIndexFocused,
                setCurrentPreviewIndexFocused,
                indexFocusedByClick,
                setIndexFocusedByClick,
            }}
        >
            {children}
        </UsePreviewKeyBoardContext.Provider>
    );
};

export const usePreviewKeyBoardContext = (): UsePreviewKeyBoardContextProps =>
    useContext<UsePreviewKeyBoardContextProps>(UsePreviewKeyBoardContext);
